<script setup>
  import ComponentButton from "@components/Buttons/Button.vue";
  import ComponentIconButton from "@components/Buttons/IconButton.vue";
  import ComponentLinkButton from "@components/Buttons/LinkButton.vue";
  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "PagesDevButtons",
  });
</script>

<template>
  <div class="grid grid-cols-3 gap-x-12 gap-y-4 md:grid-cols-4">
    <div class="flex flex-col items-center space-y-4">
      <h1 class="text-xl font-semibold">&lt;ComponentButton&gt;</h1>

      <ComponentButton label="Button" />
      <ComponentButton label="Button" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary"</h2>
      <ComponentButton label="Button" class="p4umc-primary" />
      <ComponentButton label="Button" class="p4umc-primary" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent"</h2>
      <ComponentButton label="Button" class="p4umc-accent" />
      <ComponentButton label="Button" class="p4umc-accent" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-flat"</h2>
      <ComponentButton label="Button" class="p4umc-flat" />
      <ComponentButton label="Button" class="p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary p4umc-flat"</h2>
      <ComponentButton label="Button" class="p4umc-primary p4umc-flat" />
      <ComponentButton label="Button" class="p4umc-primary p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent p4umc-flat"</h2>
      <ComponentButton label="Button" class="p4umc-accent p4umc-flat" />
      <ComponentButton label="Button" class="p4umc-accent p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />
    </div>

    <div class="flex flex-col items-center space-y-4">
      <h1 class="text-xl font-semibold">&lt;ComponentButton icon-button&gt;</h1>

      <ComponentButton icon-button label="Button">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary"</h2>
      <ComponentButton icon-button label="Button" class="p4umc-primary">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" class="p4umc-primary" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent"</h2>
      <ComponentButton icon-button label="Button" class="p4umc-accent">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" class="p4umc-accent" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-flat"</h2>
      <ComponentButton icon-button label="Button" class="p4umc-flat">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" class="p4umc-flat" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary p4umc-flat"</h2>
      <ComponentButton icon-button label="Button" class="p4umc-primary p4umc-flat">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" class="p4umc-primary p4umc-flat" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent p4umc-flat"</h2>
      <ComponentButton icon-button label="Button" class="p4umc-accent p4umc-flat">
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>
      <ComponentButton icon-button label="Button" class="p4umc-accent p4umc-flat" disabled>
        <ComponentIcon>content_copy</ComponentIcon>
      </ComponentButton>

      <hr class="border-2 border-green-50" />
    </div>

    <div class="flex flex-col items-center space-y-4">
      <h1 class="text-xl font-semibold">&lt;ComponentIconButton&gt;</h1>

      <ComponentIconButton icon="content_copy" />
      <ComponentIconButton icon="content_copy" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary"</h2>
      <ComponentIconButton icon="content_copy" class="p4umc-primary" />
      <ComponentIconButton icon="content_copy" class="p4umc-primary" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent"</h2>
      <ComponentIconButton icon="content_copy" class="p4umc-accent" />
      <ComponentIconButton icon="content_copy" class="p4umc-accent" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-flat"</h2>
      <ComponentIconButton icon="content_copy" class="p4umc-flat" />
      <ComponentIconButton icon="content_copy" class="p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary p4umc-flat"</h2>
      <ComponentIconButton icon="content_copy" class="p4umc-primary p4umc-flat" />
      <ComponentIconButton icon="content_copy" class="p4umc-primary p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent p4umc-flat"</h2>
      <ComponentIconButton icon="content_copy" class="p4umc-accent p4umc-flat" />
      <ComponentIconButton icon="content_copy" class="p4umc-accent p4umc-flat" disabled />

      <hr class="border-2 border-green-50" />
    </div>

    <div class="flex flex-col items-center space-y-4">
      <h1 class="text-xl font-semibold">&lt;ComponentLinkButton&gt;</h1>

      <ComponentLinkButton label="Button" href="#" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary"</h2>
      <ComponentLinkButton label="Button" href="#" class="p4umc-primary" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent"</h2>
      <ComponentLinkButton label="Button" href="#" class="p4umc-accent" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-flat"</h2>
      <ComponentLinkButton label="Button" href="#" class="p4umc-flat" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-primary p4umc-flat"</h2>
      <ComponentLinkButton label="Button" href="#" class="p4umc-primary p4umc-flat" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />

      <h2 class="text-lg">class="p4umc-accent p4umc-flat"</h2>
      <ComponentLinkButton label="Button" href="#" class="p4umc-accent p4umc-flat" />
      <div class="p-2 outline-dotted">no disabled link button</div>

      <hr class="border-2 border-green-50" />
    </div>
  </div>
</template>
